import { userAxios } from '../../index'

/**
 * Ítems que no reciben el descuento de membresía sobre lo no cubierto.
 * GET /api/membership-discount-exemptions
 * PUT /api/membership-discount-exemptions { type, id, exempt }
 */

const listExemptions = async () => {
  const response = await userAxios.get('membership-discount-exemptions')
  return response.data
}

const updateExemption = async (payload) => {
  const response = await userAxios.put('membership-discount-exemptions', payload)
  return response.data
}

export default {
  listExemptions,
  updateExemption,
}
